import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent implements OnInit {

  @Input() message = 'Confirm?';
  @Input() okLabel = 'Ok';
  @Input() cancelLabel = 'Cancel';
  @Output() onClose = new EventEmitter<boolean>();
  @Output() onAccept = new EventEmitter<boolean>();
  // @Output() onDismiss = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
  }

  clickAccept() {
    this.onAccept.emit(true);
    this.onClose.emit(true);
  }

  clickCanel() {
    this.onClose.emit(true);
  }

}
